module.exports = __webpack_public_path__ + "static/media/torch-full.ec750970.png";